import { render, staticRenderFns } from "./RiskManage.vue?vue&type=template&id=18b6e7e4&scoped=true"
import script from "./RiskManage.vue?vue&type=script&lang=js"
export * from "./RiskManage.vue?vue&type=script&lang=js"
import style0 from "./RiskManage.vue?vue&type=style&index=0&id=18b6e7e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b6e7e4",
  null
  
)

export default component.exports